import { WindowLocation } from '@reach/router';

const SCRIPT_DELAY_MS = 3000;
const TRUSTPILOT_SCRIPT_URL = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
const RECURLY_URL = 'https://js.recurly.com/v4/recurly.js';
const KLAVIYO_OBJECT_SCRIPT = `!function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();`;
const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const loadRecurly = async () => {
  loadScriptFromURL(RECURLY_URL, 'recurly');
};

export const loadThirdPartyScripts = async (location: WindowLocation) => {
  loadScriptFromURL(TRUSTPILOT_SCRIPT_URL, 'trustpilot');
  const pathname = location.pathname || '';
  if (!pathname.includes('event-signup') && !pathname.includes('health-for-dinner-signup')) {
    loadScriptInline(KLAVIYO_OBJECT_SCRIPT, 'klaviyo-object');
  }
};

export const loadScriptFromURL = (url: string, id: string) => {
  const scriptIsOnPage = document.getElementById(id);
  if (scriptIsOnPage) return;
  const head = document.getElementsByTagName('head')[0];
  const newScript = document.createElement('script');
  newScript.type = 'text/javascript';
  newScript.src = url;
  newScript.async = true;
  newScript.defer = true;
  newScript.id = id;
  head.appendChild(newScript);
};

export const loadScriptInline = (script: string, id: string, forceAppend: boolean = false) => {
  const scriptIsOnPage = document.getElementById(id);
  if (scriptIsOnPage && !forceAppend) return;
  const head = document.getElementsByTagName('head')[0];
  const newScript = document.createElement('script');
  newScript.type = 'text/javascript';
  newScript.innerHTML = script;
  newScript.async = true;
  newScript.defer = true;
  newScript.id = id;
  head.appendChild(newScript);
};
